/**
 * 全局 $fetch 401 统一处理（仅客户端）：
 * 任意接口返回 401 时，先清除登录信息（store + 本地缓存 + Cookie），再重定向到 /login，
 * 无需在每个页面写重定向逻辑。
 *
 * 说明：$fetch / useFetch 在调用时读取 globalThis.$fetch，因此不依赖插件执行顺序；
 * 走 $http 的请求由 plugins/http 自带的 401 处理负责。
 */
import { clearClientAuthStorage } from '@/utils/authState';

export default defineNuxtPlugin(nuxtApp => {
	const current = globalThis.$fetch as typeof $fetch & { create?: typeof $fetch.create };
	if (!current?.create) return;

	// 并发请求同时返回 401 时只处理一次，避免重复跳转
	let handling = false;

	/** 清除登录态：优先走 store（内存 + 本地存储），store 不可用时兜底清本地存储 */
	function clearLoginState() {
		try {
			useAuthStore().reset();
		} catch (e) {
			console.error('[auth] reset store failed:', e);
			clearClientAuthStorage();
		}
	}

	globalThis.$fetch = current.create({
		async onResponseError({ response }) {
			if (response?.status !== 401 || handling) return;

			// 已在登录页则无需重复处理
			const router = nuxtApp.$router as unknown as { currentRoute?: { value?: { path?: string } } } | undefined;
			if (router?.currentRoute?.value?.path === '/login') return;

			handling = true;
			try {
				await nuxtApp.runWithContext(() => {
					clearLoginState();
					return navigateTo('/login', { replace: true });
				});
			} finally {
				handling = false;
			}
		},
	});
});
